import { useEffect, useState } from 'react';

import fetchWrapper from '@/services/fetchWrapper.service';

export default function useRandomizedHomeLinks({
  endpoint,
  limitParam,
  limit,
  enabled = true,
  injectToken = false,
  optionalToken = true,
  errorMessage = 'Unable to refresh content at the moment.',
}) {
  const [state, setState] = useState({
    loading: enabled,
    data: [],
    error: null,
  });

  useEffect(() => {
    if (!enabled) {
      setState((prevValue) =>
        prevValue.loading ? { ...prevValue, loading: false } : prevValue
      );
      return;
    }

    let canceled = false;
    setState((prevValue) => ({ ...prevValue, loading: true, error: null }));

    async function fetchRandomizedItems() {
      try {
        const { response, data } = await fetchWrapper.get(
          `${endpoint}?${limitParam}=${limit}`,
          { injectToken, optionalToken }
        );

        if (canceled) {
          return;
        }

        if (response.ok && Array.isArray(data)) {
          setState({ loading: false, data, error: null });
        } else {
          setState({
            loading: false,
            data: Array.isArray(data) ? data : [],
            error: errorMessage,
          });
        }
      } catch (error) {
        if (canceled) {
          return;
        }

        setState({
          loading: false,
          data: [],
          error: error?.message || errorMessage,
        });
      }
    }

    fetchRandomizedItems();

    return () => {
      canceled = true;
    };
  }, [enabled, endpoint, limitParam, limit, injectToken, optionalToken, errorMessage]);

  return state;
}
